import { render, staticRenderFns } from "./card.vue?vue&type=template&id=463dac80&scoped=true&"
var script = {}
import style0 from "./card.vue?vue&type=style&index=0&id=463dac80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463dac80",
  null
  
)

export default component.exports